import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export function useIdentityStatus() {
  return useQuery({
    queryKey: ['identity', 'status'],
    queryFn: () => api.identity.status(),
  });
}

export function useStartIdentity() {
  return useMutation({
    mutationFn: () => api.identity.session(),
    onSuccess: (result) => {
      if (result.url) {
        window.location.href = result.url;
      }
    },
  });
}
